var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.datum)?_c('span',{staticClass:"datumLetzerBesuchsbericht"},[_vm._v(" "+_vm._s(_vm.datum && _vm.datum != '---' ? _vm.javaDateToDefaultDateFormat(_vm.datum) : '--')+" ")]):(_vm.loading)?_c('span',[_c('b-icon',{attrs:{"icon":"clock","animation":"spin","font-scale":"1"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }